var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1609_5761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1609_5761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 14H4.66683V5.33332L9.3335 0.666656L10.1668 1.49999C10.2446 1.57777 10.3085 1.68332 10.3585 1.81666C10.4085 1.94999 10.4335 2.07777 10.4335 2.19999V2.43332L9.70016 5.33332H14.0002C14.3557 5.33332 14.6668 5.46666 14.9335 5.73332C15.2002 5.99999 15.3335 6.3111 15.3335 6.66666V7.99999C15.3335 8.07777 15.3224 8.1611 15.3002 8.24999C15.2779 8.33888 15.2557 8.42221 15.2335 8.49999L13.2335 13.2C13.1335 13.4222 12.9668 13.6111 12.7335 13.7667C12.5002 13.9222 12.2557 14 12.0002 14ZM6.00016 12.6667H12.0002L14.0002 7.99999V6.66666H8.00016L8.90016 2.99999L6.00016 5.89999V12.6667ZM4.66683 5.33332V6.66666H2.66683V12.6667H4.66683V14H1.3335V5.33332H4.66683Z",
    fill: "black",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb_up.4ef6b527fc9b3d74c64d1130447a8244.svg";
export { ForwardRef as ReactComponent };